import { render, staticRenderFns } from "./addClientDialog.vue?vue&type=template&id=04499bf6&scoped=true&"
import script from "./addClientDialog.vue?vue&type=script&lang=js&"
export * from "./addClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./addClientDialog.vue?vue&type=style&index=0&id=04499bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04499bf6",
  null
  
)

export default component.exports